export class ReviewHeaderData { 
    estimateName: string = ''; 
    accountName: string = ''; 
    shipToAddress: string = ''; 
    sellPrice: number = 0.00; 
    tdc: number = 0.00;
    gm: string = '';
    status: string = '';  
}